import { Box, Typography } from "@mui/material";
import { getEventColor } from "../../../../common/Utils/Utils";
import { black } from "../../../../../theme/colours";

const ScoreCard = ({ event, value, icon }) => {
  const colorBox = {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "1.5rem",
    m: "0.2rem 0.4rem 0.2rem 0rem",
    p: "0.2rem 0.4rem",
    background: getEventColor(value),
    borderRadius: "0.2rem",
  };
  const noColorBox = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    p: "0.2rem 2%",
    borderRadius: "0.2rem",
  };
  const imgStyle = {
    width: "0.8rem",
    height: "0.8rem",
    mr: event ? "0.2rem" : "0.3rem",
  };
  const textStyle = {
    color: black,
  };

  return (
    <Box sx={event ? { ...noColorBox } : { ...colorBox }}>
      <Box
        sx={imgStyle}
        component="img"
        src={`images/trypsIcons/${icon}.svg`}
        alt="event-icon"
      />
      <Typography sx={textStyle}>{value}</Typography>
    </Box>
  );
};

export default ScoreCard;
